<template>
  <UiListItem>
    <UiLink v-if="item.link" :to="item.link" class="text-decoration-none">
      <UiText
        variant="body-3"
        color="text-primary"
        class="list-item__text"
        :class="{ 'list-item__text--truncated': isSidebarOpen }"
      >
        <AppTranslate :identifier="currentText" />
      </UiText>
    </UiLink>
    <UiText
      v-else
      variant="body-3"
      color="text-primary"
      class="list-item__text"
      :class="{ 'list-item__text--truncated': isSidebarOpen }"
    >
      <AppTranslate :identifier="currentText" />
    </UiText>
  </UiListItem>
</template>

<script setup lang="ts">
import { UiLink, UiListItem, UiText } from '~/ui';
import type { SidebarItem } from '~/app/layouts/sidebar';
import { AppTranslate } from '~/infrastructure';
import { computed } from 'vue';

export interface Props {
  item: SidebarItem;
  isSidebarOpen: boolean;
}
const { item, isSidebarOpen } = defineProps<Props>();

const currentText = computed(() =>
  isSidebarOpen ? item.label : (item.shortLabel ?? item.label),
);
</script>

<style scoped lang="scss">
.list-item {
  &__text {
    &--truncated {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      width: 100%;
    }
  }
}
</style>
